var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 348,
    height: 206,
    viewBox: "0 0 348 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "back_svg__a",
    d: "M193.17-3.23l-.362.187a22.1 22.1 0 00-11.71 19.5l-.001 34.986H23.547c-11.146 0-19.1 3.903-23.819 11.272-3.251 5.077-4.7 11.104-5.165 19.003l-.064 1.23a101.3 101.3 0 00-.05 1.26l-.026.929-.02.975-.015 1.003-.011 1.056v2.234l.008 1.288.016 1.25.026 1.21c.01.399.022.79.035 1.176l.046 1.142c.017.375.036.744.057 1.108l.068 1.078c.421 6.02 1.426 10.622 3.5 15.12l.185.393c4.417 9.221 12.825 14.38 25.23 14.38l157.55-.001v34.987a22.07 22.07 0 0012.072 19.678 22.175 22.175 0 0010.03 2.411 22.04 22.04 0 0012.995-4.232l101.31-73.53a22.096 22.096 0 009.12-17.866c0-7.082-3.39-13.727-9.124-17.88L216.18-1.42a22.167 22.167 0 00-22.616-2.007l-.396.195zm16.41 10.92L310.9 81.225a10.821 10.821 0 014.479 8.773c0 3.456-1.665 6.715-4.482 8.764l-101.32 73.537a10.8 10.8 0 01-6.374 2.077c-1.694 0-3.38-.404-4.938-1.193a10.817 10.817 0 01-5.914-9.646v-46.236h-168.8c-8.231 0-12.689-2.792-15.197-8.232-1.137-2.467-1.843-5.219-2.25-8.706l-.092-.851a57.636 57.636 0 01-.081-.881l-.07-.912c-.012-.155-.022-.31-.032-.468l-.055-.961a87.151 87.151 0 01-.024-.494l-.041-1.013-.032-1.05-.024-1.088-.008-.558-.014-1.148v-.589l.005-2.441.014-1.277.023-1.194.025-.882.017-.463.039-.91.048-.888.028-.435.062-.856.071-.834.082-.812c.029-.267.06-.531.092-.791l.102-.77c1.485-10.507 6.04-14.994 16.917-15.1l169.2-.002V16.459A10.85 10.85 0 01198 6.943l.265-.14a10.914 10.914 0 0111.322.888z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "back_svg__b",
    d: "M203.72 131.92v40.611c0 6.19 3.471 11.854 8.996 14.664a16.541 16.541 0 007.48 1.8c3.417 0 6.822-1.065 9.678-3.15l101.32-73.539a16.47 16.47 0 006.8-13.314c0-5.28-2.527-10.23-6.8-13.325l-101.32-73.539a16.54 16.54 0 00-17.158-1.35 16.474 16.474 0 00-8.996 14.675v40.611H40.54c-22.752 0-23.547 18.129-23.547 32.68 0 13.561.794 33.175 23.547 33.175h163.18z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 348.34 0)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    fill: "#7084b1",
    fillRule: "nonzero",
    transform: "translate(17 9)",
    xlinkHref: "#back_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    fill: "#fff",
    stroke: "#7084b1",
    strokeWidth: 11.25,
    xlinkHref: "#back_svg__b"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.12eff128.svg";
export { ForwardRef as ReactComponent };